import { create } from 'zustand';
import axios from 'axios';
import { adminWorkflowsApi } from '@api/api-config.ts';
import { AdminWorkflowDetailDTO, AdminWorkflowListItemDTO } from '@api/generated/search-service';

interface AdminWorkflowStoreState {
  list: AdminWorkflowListItemDTO[];
  listLoading: boolean;
  listError: string | null;

  detail: AdminWorkflowDetailDTO | null;
  detailLoading: boolean;
  detailError: string | null;

  loadWorkflows: () => Promise<void>;
  loadWorkflowDetail: (name: string) => Promise<void>;
}

const errorMessage = (e: unknown) =>
  axios.isAxiosError(e) ? ((e.response?.data as { message?: string })?.message ?? e.message) : String(e);

export const useAdminWorkflowStore = create<AdminWorkflowStoreState>((set, get) => ({
  list: [],
  listLoading: false,
  listError: null,

  detail: null,
  detailLoading: false,
  detailError: null,

  loadWorkflows: async () => {
    set({ listLoading: true, listError: null });
    try {
      const response = await adminWorkflowsApi.getAdminWorkflowList();
      set({ list: response.data, listLoading: false });
    } catch (e) {
      set({ listLoading: false, listError: errorMessage(e) });
    }
  },

  loadWorkflowDetail: async (name: string) => {
    // Pri prechodu na jine workflow nenechavat na obrazovce graf predchoziho
    if (get().detail?.name !== name) {
      set({ detail: null });
    }
    set({ detailLoading: true, detailError: null });
    try {
      const response = await adminWorkflowsApi.getAdminWorkflowDetail({ name });
      set({ detail: response.data, detailLoading: false });
    } catch (e) {
      set({ detail: null, detailLoading: false, detailError: errorMessage(e) });
    }
  },
}));
